/* mazo-hero-carousel.js: the home hero carousel (sections/mazo-hero.liquid; styles: the "Hero carousel" block at the end of mazo-hero.css), 2026-10-15.
   Dots, auto advance (data-interval ms), pause while hovered, focused or touched, swipe on touch screens.
   Reduced motion: no auto advance (dots and swipe still work). Hidden tab: paused.
   Slides that are not shown get aria-hidden + inert, so keyboard and screen readers only reach the visible one. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mazo-hero-carousel]');
  if (!root) return;
  var pics = root.querySelectorAll('.mazo-hero__picture');
  var slides = root.querySelectorAll('.mazo-hero__slide');
  var dots = root.querySelectorAll('.mazo-hero__dot');
  var n = slides.length, cur = 0, timer = null, hold = false;
  var every = parseInt(root.getAttribute('data-interval'), 10) || 6000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (n < 2) return;

  /* Slides 2+ ship their image addresses as data-mz-srcset / data-mz-src (mazo-hero.liquid) so they do not compete
     with the first slide's LCP image. Restore them once the page has loaded, or right away if a slide is asked for. */
  var restored = false;
  function restore() {
    if (restored) return; restored = true;
    root.querySelectorAll('[data-mz-srcset]').forEach(function (el) { el.setAttribute('srcset', el.getAttribute('data-mz-srcset')); el.removeAttribute('data-mz-srcset'); });
    root.querySelectorAll('[data-mz-src]').forEach(function (el) { el.setAttribute('src', el.getAttribute('data-mz-src')); el.removeAttribute('data-mz-src'); });
  }
  /* T772 (29 Oct 2026): autoplay is armed at the same moment the pictures are restored (1.5 s after the load event), not when this script runs.
     Before, the 6 s timer fired while the page was still loading, called show() and restore() pulled the 2nd 290 KB picture in BEFORE the load
     event, so on a slow phone the browser's load bar waited for a picture nobody had asked for yet. A dot press or swipe still shows a slide at once. */
  var armed = false;
  function arm() { if (armed) return; restore(); armed = true; start(); }
  if (document.readyState === 'complete') setTimeout(arm, 1500);
  else window.addEventListener('load', function () { setTimeout(arm, 1500); });
  setTimeout(arm, 20000);   /* safety net: if a slow third party keeps the load event waiting, the carousel still starts */

  function show(i) {
    restore();
    cur = (i + n) % n;
    for (var k = 0; k < n; k++) {
      var on = k === cur;
      if (pics[k]) pics[k].classList.toggle('is-active', on);
      slides[k].classList.toggle('is-active', on);
      if (on) { slides[k].removeAttribute('aria-hidden'); slides[k].inert = false; }
      else { slides[k].setAttribute('aria-hidden', 'true'); slides[k].inert = true; }
      if (dots[k]) { dots[k].classList.toggle('is-active', on); dots[k].setAttribute('aria-selected', on ? 'true' : 'false'); }
    }
  }
  /* The first automatic change keeps its old moment (6 s after the page opened) when the page was quick, but never comes sooner than 2.5 s after
     the 2nd picture was asked for, so the picture is there when the slide fades in. Later changes are every 6 s as before. */
  var lead = true;
  function stop() { if (timer) { clearInterval(timer); clearTimeout(timer); timer = null; } }
  function start() {
    stop();
    if (!armed || reduce || hold || document.hidden) return;
    var gap = every;
    if (lead) { lead = false; gap = Math.max(every - performance.now(), 2500); }
    timer = setTimeout(function () { show(cur + 1); timer = setInterval(function () { show(cur + 1); }, every); }, gap);
  }

  for (var d = 0; d < dots.length; d++) {
    dots[d].addEventListener('click', function (e) { show(parseInt(e.currentTarget.getAttribute('data-go'), 10)); start(); });
  }
  root.addEventListener('mouseenter', function () { hold = true; stop(); });
  root.addEventListener('mouseleave', function () { hold = false; start(); });
  root.addEventListener('focusin', function () { hold = true; stop(); });
  root.addEventListener('focusout', function () { hold = false; start(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

  /* Swipe: a mostly horizontal move of 40px or more changes the slide. Vertical scrolling is left alone. */
  var x0 = null, y0 = null;
  root.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; stop(); }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
    x0 = y0 = null; start();
  }, { passive: true });

  start();
})();
